<!-- Do not change this file. -->
<template>
  <div v-if="enabled">
    <div class="border-env border-top" :class="`border-${backgroundClass}`">
      <div class="border-env-label position-absolute top-0">
        <div class="badge fs-3" :class="`bg-${backgroundClass}`">
          {{ label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "EnvLabel",
  props: {
    backgroundClass: {
      type: String,
      default: "danger",
      validator: (value) => {
        return [
          "primary",
          "secondary",
          "warning",
          "danger",
          "info",
          "success",
          "light"
        ].includes(value);
      }
    },
    label: {
      type: String,
      default: "Development",
      validate(value) {
        return typeof value === "string" && value.trim().length > 0;
      }
    }
  },
  computed: {
    enabled() {
      return this.domainLabel !== "";
    },
    domainLabel() {
      const currentUrl = window.location.hostname;

      if (currentUrl.includes("demo.")) {
        return "Demo";
      } else if (currentUrl.includes("test.")) {
        return "Testing";
      } else if (currentUrl.includes("web.")) {
        return "";
      }

      return "Development";
    }
  }
};
</script>

<style scoped>
.border-env {
  border-width: 20px !important;
}
.border-env-label {
  z-index: 1;
  width: 100% !important;
}
</style>
